import { type ComponentType, useEffect } from 'react';
import usePageLoadedSubscriber from '@atlassian/jira-spa-state-controller/src/components/page-loaded-state/index.tsx';
import { useLazyPhase } from '@atlassian/react-loosely-lazy';
import { fg } from '@atlassian/jira-feature-gating';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const LoadingPhaseManager: ComponentType<Record<any, any>> = () => {
	const [{ hasLoaded }] = usePageLoadedSubscriber();
	const { resetPhase, startNextPhase } = useLazyPhase();

	useEffect(() => {
		if (fg('iv_load_after_paint_phase_on_page_early')) {
			performance.mark('rll-after-paint-phase');
			startNextPhase();
		} else if (hasLoaded) {
			performance.mark('rll-after-paint-phase');
			startNextPhase();
		} else {
			resetPhase();
		}
	}, [hasLoaded, resetPhase, startNextPhase]);

	return null;
};

export { LoadingPhaseManager };
